import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-mobile-info-modal',
  imports: [TranslateModule],
  templateUrl: './mobile-info-modal.component.html',
  styleUrl: './mobile-info-modal.component.scss'
})
export class MobileInfoModalComponent {
  
  public serveProd = environment.serveProd;
  private translate = inject(TranslateService);

  getGooglePlayBadgeSrc(): string {
    const lang = this.translate.getCurrentLang();
    switch (lang) {
      case 'es':
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_Spanish.svg';
      case 'fr':
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_French.svg';
      default:
        return 'assets/images/badges/GetItOnGooglePlay_Badge_Web_color_English.svg';
    }
  }

  getAppStoreBadgeSrc(): string {
    const lang = this.translate.getCurrentLang();
    switch (lang) {
      case 'es':
        return 'assets/images/badges/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';
      case 'fr':
        return 'assets/images/badges/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.svg';
      default:
        return 'assets/images/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
    }
  }
}
